import { useEffect } from 'react';
import useLoadNewInvoices from './useLoadNewInvoices';

const useLoadNewInvoicesOnMount = () => {
  const { loadNewInvoices, selectedCompanyHasSiiCredentials } = useLoadNewInvoices();

  useEffect(() => {
    if (selectedCompanyHasSiiCredentials) {
      loadNewInvoices();
    }
  }, [selectedCompanyHasSiiCredentials, loadNewInvoices]);
};

export default useLoadNewInvoicesOnMount;
